/**
 * Legacy cameras originate from the old A3 system. They are identified by
 * a `legacy_app` asset source (source code "3"), which produces an AssetId
 * beginning with "A3-". In the CameraId format `{siteId}/{assetId}@{cameraId}`,
 * the asset portion starts immediately after the first `/`.
 *
 * Their permissions are managed by legacy syncs and should not be modified
 * by the new permission endpoints.
 *
 * This utility is shared between server handlers (which skip legacy cameras
 * during permission mutations) and client code (which disables legacy camera
 * rows in the UI). Both must use the same signal.
 */
export function isLegacyCamera(cameraId: string): boolean {
  const slashIndex = cameraId.indexOf("/");
  if (slashIndex === -1) return false;
  const afterSlash = cameraId.substring(slashIndex + 1);
  return afterSlash.startsWith("A3-");
}
